"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.omitEventsRequestNonFiqlFilters = omitEventsRequestNonFiqlFilters;
exports.omitEventsCountersRequestNonFiqlFilters = omitEventsCountersRequestNonFiqlFilters;
/**
 * Helper function to omit request params confilt with fiql
 * @param request EventsApiGetEventsV2Request
 * @returns EventsApiGetEventsV2Request
 */
function omitEventsRequestNonFiqlFilters(request) {
    return {
        fiql: request.fiql,
        locale: request.locale,
        sort: request.sort,
        pageKey: request.pageKey,
        pageKeyDirection: request.pageKeyDirection,
        pageSize: request.pageSize,
        withCursor: request.withCursor,
    };
}
/**
 *  Helper function to omit request params confilt with fiql
 * @param request EventsApiGetEventCountersRequest
 * @returns EventsApiGetEventCountersRequest
 */
function omitEventsCountersRequestNonFiqlFilters(request) {
    return {
        fiql: request.fiql,
        locale: request.locale,
        aggregateByGeneric: request.aggregateByGeneric,
    };
}
//# sourceMappingURL=utils.js.map